import script from "./HomagePage.vue?vue&type=script&setup=true&lang=js"
export * from "./HomagePage.vue?vue&type=script&setup=true&lang=js"

import "./HomagePage.vue?vue&type=style&index=0&id=24f45a99&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24f45a99"]])

export default __exports__